import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/office/")({
  beforeLoad: async () => {
    throw redirect({
      to: "/office/tasks",
    });
  },
});
